/**
 * Created by r4zi4l on 06.09.2022
 */

const ClansInfoTab = cc.Node.extend({
    ctor: function (options, clan) {
        const styles = cleverapps.styles.ClansInfoTab;

        this._super();
        this.clan = clan || cleverapps.userClan;

        this.setContentSize2(options.width, options.height);

        this.createTableBg();
        this.createTable();
        this.createFooter();

        if (cleverapps.userClan.id === undefined) {
            const joinButton = this.createJoinButton();
            joinButton.setAlignment(styles.joinButton);
            this.addChild(joinButton);
        } else if (cleverapps.userClan.id === this.clan.id) {
            const leaveButton = this.createLeaveButton();
            leaveButton.setAlignment(styles.leaveButton);
            this.addChild(leaveButton);

            if (this.clan.getOwner() === connector.platform.getUserID()) {
                const editButton = this.createEditButton();
                editButton.setAlignment(styles.editButton);
                this.addChild(editButton);
            }
        }
    },

    createTableBg: function () {
        const styles = cleverapps.styles.ClansInfoTab;

        const rect = cc.rectSubPadding(cc.rect(0, 0, this.width, this.height), cc.padding(styles.padding));

        const tableBg = this.tableBg = cleverapps.UI.createScale9Sprite(bundles.clan.frames.table_bg, cleverapps.UI.Scale9Rect.TwoPixelXY);
        tableBg.setContentSize2(rect.width, rect.height);
        tableBg.setAnchorPoint(0, 0);
        tableBg.setAlignment(rect.x, rect.y);
        this.addChild(tableBg);

        const foreground = cleverapps.UI.createScale9Sprite(bundles.clan.frames.table_fg, cleverapps.UI.Scale9Rect.TwoPixelXY);
        foreground.setContentSize2(tableBg.width, tableBg.height);
        foreground.setAnchorPoint(0, 0);
        foreground.setAlignment(0, 0);
        tableBg.addChild(foreground, 1);
    },

    createTable: function () {
        const styles = cleverapps.styles.ClansInfoTab.table;

        const rect = cc.rectSubPadding(cc.rect(0, 0, this.tableBg.width, this.tableBg.height), cc.padding(styles.padding));

        const dataSource = StaticDataSource(() => {
            const players = this.clan.players.slice();

            players.sort((a, b) => Boolean(b.isOwner()) - Boolean(a.isOwner()) || b.level - a.level);

            return players.map((player, index) => {
                const data = player.convertToRowData();
                data.data.place = index + 1;
                return data;
            });
        });

        const table = new ScrollTable(dataSource, { parentView: this });
        const tableView = new cleverapps.UI.ScrollView(new cc.Node(), {
            scrollBarEnabled: !table.scrollDisabled,
            mouseScroll: !table.scrollDisabled,
            dock: true
        });

        new TableHandler(table, tableView, {
            id: "infoClans",
            height: rect.height,
            rowConstructor: ClansInfoRow,
            scroll: cleverapps.UI.ScrollView.SCROLLS.UPPER_LEFT,
            innerPadding: styles.innerPadding
        });
        
        tableView.setAlignment(rect.x + rect.width / 2, rect.y + rect.height / 2);
        this.tableBg.addChild(tableView);
    },

    createFooter: function () {
        const styles = cleverapps.styles.ClansInfoTab.footer;

        const clanSize = this.createClanSize();
        const requiredLevel = this.createRequiredLevel();

        const footer = new cleverapps.Layout([clanSize, requiredLevel], {
            direction: cleverapps.UI.HORIZONTAL,
            margin: styles.margin
        });

        footer.setAlignment(styles);
        this.addChild(footer);
    },

    createClanSize: function () {
        const styles = cleverapps.styles.ClansInfoTab.clanSize;

        const bg = cleverapps.UI.createScale9Sprite(bundles.clan.frames.clan_info_bg, cleverapps.UI.Scale9Rect.TwoPixelXY);
        bg.setContentSize2(styles);

        const icon = new cc.Sprite(bundles.clan_table.frames.players_icon);
        bg.addChild(icon);
        icon.setAlignment(styles.icon);

        const text = cleverapps.UI.generateImageText(`${this.clan.membersCount}/${ClansConfig.MAX_SIZE}`, cleverapps.styles.FONTS.CLAN_LIGHT_TEXT);
        text.fitTo(styles.text.width);
        bg.addChild(text);
        text.setAlignment(styles.text);

        return bg;
    },

    createRequiredLevel: function () {
        const styles = cleverapps.styles.ClansInfoTab.requiredLevel;

        const bg = cleverapps.UI.createScale9Sprite(bundles.clan.frames.clan_info_bg, cleverapps.UI.Scale9Rect.TwoPixelXY);
        bg.setContentSize2(styles);

        const text = cleverapps.UI.generateOnlyText(Messages.get("AddClanWindow.requiredLevel"), cleverapps.styles.FONTS.CLAN_LIGHT_TEXT);
        text.setString(cleverapps.splitHalfByWord(text.getString()).join("\n"));
        text.setHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER);
        text.fitTo(undefined, styles.text.height);

        bg.addChild(text);
        text.setAlignment(styles.text);

        const levelBg = new cc.Scale9Sprite(bundles.clan_table.frames.level_background);

        const crown = new cleverapps.Spine(bundles.clan_table.jsons.level_crown);
        crown.setAlignment(styles.crown);
        crown.setAnimation(0, "idle", true);

        const amount = cleverapps.UI.generateImageText(this.clan.requiredLevel, cleverapps.styles.FONTS.MENUBAR_LEVEL_TEXT);
        amount.fitTo(styles.amount.width);
        amount.setAlignment(styles.amount);

        levelBg.addChild(amount);
        levelBg.addChild(crown);

        cleverapps.UI.fitToBox(levelBg, styles.levelBg);

        bg.addChild(levelBg);
        levelBg.setAlignment(styles.levelBg);

        return bg;
    },

    createLeaveButton: function () {
        const styles = cleverapps.styles.ClansInfoTab.leaveButton;

        return new cleverapps.UI.Button({
            width: styles.width,
            height: styles.height,
            type: cleverapps.styles.UI.Button.Images.button_red,
            text: Messages.get("ClansInfoTab.leave"),
            disabled: !this.clan.isUserClan(),
            onClicked: function () {
                cleverapps.focusManager.display({
                    focus: "ClanConfirmActionWindow",
                    stack: true,
                    action: function (f) {
                        new ClanConfirmActionWindow({
                            title: Messages.get("ClansConfirmActionWindow.leaveClan"),
                            action: function () {
                                cleverapps.clans.leave();
                            }
                        });
                        cleverapps.focusManager.onceNoWindowsListener = f;
                    }
                });
            }
        });
    },

    createEditButton: function () {
        const styles = cleverapps.styles.ClansInfoTab.editButton;

        return new cleverapps.UI.Button({
            width: styles.width,
            height: styles.height,
            type: cleverapps.styles.UI.Button.Images.button_blue,
            text: Messages.get("Edit"),
            onClicked: function () {
                cleverapps.focusManager.display({
                    focus: "AddClanWindow",
                    stack: true,
                    action: function (f) {
                        new AddClanWindow(this.clan);
                        cleverapps.focusManager.onceNoWindowsListener = f;
                    }.bind(this)
                });
            }.bind(this)
        });
    },

    createJoinButton: function () {
        const styles = cleverapps.styles.ClansInfoTab.joinButton;

        return new cleverapps.UI.Button({
            width: styles.width,
            height: styles.height,
            type: cleverapps.styles.UI.Button.Images.button_red,
            text: Messages.get("Join"),
            disabled: !this.clan.isAppropriate(),
            onClicked: function () {
                cleverapps.clans.join(this.clan.id);
            }.bind(this)
        });
    }
});

cleverapps.styles.ClansInfoTab = {
    padding: {
        x: -30,
        top: -10,
        bottom: 100
    },

    table: {
        padding: {
            x: 0,
            top: 20,
            bottom: 20
        }
    },

    footer: {
        margin: 30,
        x: { align: "left", dx: 20 },
        y: { align: "bottom", dy: -5 }
    },

    clanSize: {
        width: 250,
        height: 88,

        icon: {
            x: { align: "left", dx: 15 },
            y: { align: "center" }
        },

        text: {
            width: 150,
            x: { align: "right", dx: -20 },
            y: { align: "center" }
        }
    },

    requiredLevel: {
        width: 300,
        height: 88,

        crown: {
            x: { align: "left", dx: -20 },
            y: { align: "top", dy: 20 }
        },

        levelBg: {
            x: { align: "right", dx: -20 },
            y: { align: "center", dy: -2 },
            height: 70
        },

        text: {
            width: 200,
            height: 80,
            x: { align: "center", dx: -35 },
            y: { align: "center" }
        },

        amount: {
            x: { align: "center", dx: 1 },
            y: { align: "center", dy: 10 },
            width: 85
        }
    },

    leaveButton: {
        width: 300,
        height: 100,
        x: { align: "right" },
        y: { align: "bottom", dy: -10 }
    },

    editButton: {
        width: 300,
        height: 100,
        x: { align: "right", dx: -340 },
        y: { align: "bottom", dy: -10 }
    },

    joinButton: {
        width: 300,
        height: 100,
        x: { align: "right", dx: -20 },
        y: { align: "bottom", dy: -10 }
    }
};